import styled from "styled-components";

import { BorderlessInput } from "../BorderlessInput";
import { Button } from "../Button";
import { SelectInput } from "../SelectInput";

export const Form = styled.form`
  position: relative;
  width: 100%;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
`;

export const Input = styled(BorderlessInput)`
  :not(:first-of-type) {
    margin-top: 30px;
  }
`;

export const SelectGenderInput = styled(SelectInput)`
  margin-top: 30px;
`;

export const FormButton = styled(Button)`
  margin-top: 30px;
  height: 50px;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const CheckboxRow = styled.div`
  margin-top: 30px;
`;

export const InputContainer = styled.div`
  margin-top: 30px;
`;
